// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 623) return "js/623-ea454bfab0a8359bb35d.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "46e1c25453e0d557e51c" + ".chunk.js";
};